import Hero from "../components/Hero";
import HeroImage from "../../assets/images/New6.jpg";
import "../../css/Services.css";
import PensionImage from "../../assets/images/New Pension.jpg";
import NHSPensionImage from "../../assets/images/New1.jpg";
import InvestmentImage from "../../assets/images/New5.jpg";
import ProtectionImage from "../../assets/images/New4.jpg";
import Button from "../components/Button";

const ServicesPage = () => {
  return (
    <div className="about-us-page">
      <Hero
        title="Our Services"
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="primary-background-container-content services-grid">
        <div className="service-item">
          <div className="service-content">
            <h2 className="light">Pensions</h2>
            <div className="content-semibold">
              Making retirement right for you.
            </div>
            <div className="divider align-left" />
            <div className="content">
              Whether private, workplace, or complex schemes like the NHS
              Pension, pensions form the backbone of your retirement income,
              it’s crucial to understand what you have, how it’s performing, and
              whether it aligns with your long-term goals. As part of your
              Financial Foundations Plan we offer clear, tailored advice on
              reviewing your existing arrangements, including NHS pensions with
              their unique rules and benefits.
            </div>
            <div className="content">
              Whether you’re planning to retire early, reduce your hours, or
              simply want to know if you’re on track, we will guide you through
              your options and help build a retirement strategy that supports
              the life you want to lead.
            </div>
            <div className="content-italic">
              The value of pensions and the income they produce can fall as well
              as rise.
            </div>
            <div className="content-italic">
              You may get back less than you invested. Transferring out of a
              final salary pension is unlikely to be in the best interest of
              most people.
            </div>
          </div>
          <img src={PensionImage} alt="Pensions" className="service-image" />
        </div>
        <div className="service-item">
          <div className="service-content">
            <h2 className="light">NHS Pensions</h2>
            <div className="content-semibold">
              Supporting those who support others
            </div>
            <div className="divider align-left" />
            <div className="content">
              The NHS Pension Scheme is one of the most valuable and complex
              workplace pensions available, offering generous benefits but with
              rules that can be difficult to navigate. Understanding how your
              pension works is essential to make informed decisions about your
              future.
            </div>
            <div className="content">
              We can provide expert, personalised advice to help you understand
              your entitlements, how recent reforms may affect you, and what
              steps you can take now to optimise your retirement. Whether you’re
              considering early retirement, partial retirement, or just want
              clarity on your options, we’re here to simplify the process and
              ensure your pension works hard for the life you want to lead.
            </div>
            <div className="content-italic">
              The value of pensions and the income they produce can fall as well
              as rise.
            </div>
            <div className="content-italic">
              The value of pensions and the income they produce can fall as well
              as rise.
            </div>
          </div>
          <img src={NHSPensionImage} alt="Pensions" className="service-image" />
        </div>
        <div className="service-item">
          <div className="service-content">
            <h2 className="light">Investment</h2>
            <div className="content-semibold">
              Investing in Your Future, On Your Terms
            </div>
            <div className="divider align-left" />
            <div className="content">
              Whether your goal is to pay off your mortgage, or to save for your
              children’s future your financial journey deserves a strategy as
              unique as your aspirations.
            </div>
            <div className="content">
              As part of your <strong>Financial Foundations Plan</strong>, we go
              beyond generic solutions to craft a personalised investment
              strategy that aligns with your life goals, time horizon, and
              attitude to risk.
            </div>
            <div className="content">
              We take the time to understand what’s important to you, whether
              it’s gaining financial independence, supporting your children’s
              future, or simply having the freedom to say “yes” to new
              experiences. Your investments are then structured to support these
              ambitions, with a clear focus on growth, tax efficiency, and
              long-term sustainability.
            </div>
            <div className="content">
              With a robust investment plan in place, you gain more than just
              potential returns, you gain confidence in your future. Regular
              reviews and adjustments ensure your strategy evolves as your
              circumstances and goals do, giving you a clear, flexible roadmap
              to financial security and the life you want to live.
            </div>
            <div className="content">
              Because building wealth isn’t just about money it’s about making
              your life goals a reality.
            </div>
            <div className="content-italic">
              The value of investments and the income they produce can fall as
              well as rise. You may get back less than you invested.
            </div>
          </div>
          <img src={InvestmentImage} alt="Pensions" className="service-image" />
        </div>
        <div className="service-item">
          <div className="service-content">
            <h2 className="light">Protection</h2>
            <div className="content-semibold">
              Having a policy to suit your lifestyle
            </div>
            <div className="divider align-left" />
            <div className="content">
              Your future goals whether personal or professional are worth
              protecting. That’s why financial protection is the foundation of
              any robust plan. The right protection policies provide peace of
              mind, ensuring that if the unexpected happens, your loved ones
              remain financially secure, and your long-term objectives stay
              within reach. Without this safety net, even the best-laid plans
              can be left vulnerable.
            </div>
            <div className="content">
              Protection comes in many forms, each designed to safeguard
              different aspects of your life and income.
            </div>
            <div className="content">
              <strong>Income protection</strong> replaces a portion of your
              earnings if you’re unable to work due to illness or injury,
              helping you maintain your lifestyle during recovery.
            </div>
            <div className="content">
              <strong>Life assurance</strong> provides a lump sum to your loved
              ones in the event of your death offering financial stability when
              it’s needed most.
            </div>
            <div className="content">
              <strong>Critical illness insurance</strong> pays out if you’re
              diagnosed with a serious condition such as cancer, stroke, or
              heart disease, giving you the freedom to focus on recovery without
              financial strain.
            </div>
            <div className="content">
              <strong>Business protection insurance</strong> helps secure the
              future of your company, whether it’s covering key personnel,
              ensuring continuity, or supporting succession planning.
            </div>
            <div className="content">
              In short, protection is not just a product, it’s a powerful tool
              that underpins your entire Financial Foundations Plan, giving you
              and those you care about the resilience to thrive, no matter what
              life brings.
            </div>
          </div>
          <img src={ProtectionImage} alt="Pensions" className="service-image" />
        </div>
      </div>
      <Button text="CONTACT US" variant="primary" />
    </div>
  );
};
export default ServicesPage;
